import {getArgs} from './args.js';
import {lazy} from './lazy.js';
import {getSlicedParameters, sliceParams} from './params.js';

export const byDevice = (... fns) => {
    let slicer = sliceParams();
   return (... args) => {
       let {effect} = getArgs(args);
       let {history} = getArgs(args);
       let {coords} = getArgs(args);
       coords = getSlicedParameters(slicer, coords, args.slice(1));
       
       let deviceToParameters = {};
       for (let id in coords) {
           // find parameter
           let parameter = getParameterForId(id, effect);
           if (!parameter) { continue; };
           let {context} = parameter;
           let device = context.subDevice || context.subDevice || context.device || context.track || context.lfoTrack;
           if (!device) { continue; }
           let _id = device.id || device.name || device.number;
           if (!_id) { continue; }
           if (!deviceToParameters[_id]) {
               deviceToParameters[_id] = {};
                   
           }
           deviceToParameters[_id][id] = coords[id];
       }

       let i=0;
       let _coords = {};
      for (let id in deviceToParameters) {
           _coords = {
               ... _coords,
               ...fns[i % fns.length](deviceToParameters[id], ... args.slice(1))
           };
       }
       return _coords;
   };
};

const getParameterForId = (id, effect) => {
    for (let group of effect.groups) {
        if (id in group.idToParameter) {
            return group.idToParameter[id];
        }
    }
    
    return undefined;
};

export const not = (notCoords) => {
    return (... args) => {
        let {coords} = getArgs(args);
        let _notCoords = lazy(notCoords, ...args);

        // only pass through coords that are NOT in notCoords
        let pass = {};
        for (let id in coords) {
            if (!(id in _notCoords)) {
                pass[id] = coords[id];
            }
        }
        return pass;
    };
};

export const search = (... terms) => {
    let cache = {};
    return (... args) => {
        let {effect} = getArgs(args);
        let {history} = getArgs(args);
        let {coords} = getArgs(args);
        if (history.length < 1) {
            // todo: need to check if parameters changed, i.e.
            // some new parameter has beena dded
            cache = {};
        }
        let parameters = [];
        for (let term of terms) {
            if (!(term in cache)) {
                cache[term] = effect._parameters.filter(
                    paramMatches(term));
            } 
            parameters = [
                ... parameters,
                ... cache[term]
                ];
        }

        let ids = new Set(parameters.map(p => p.id));
        let filteredCoords = {};
        ids.forEach(
            id => filteredCoords[id] = coords[id]);
        return filteredCoords;
    };
};

const paramMatches = (term) => (param) => {
    term = term.toLowerCase();
    return getParamNames(param).some(
        n => n.includes(term));
};

const getParamNames = (p) => {
    let names = [];
    if (p.context) {
        if (p.context.subDevice && p.context.subDevice.name) {
            names.push(p.context.subDevice.name.toLowerCase());
        }
        if (p.context.effect && p.context.effect.name) {
           names.push(p.context.effect.name.toLowerCase());
        }
        if (p.context.midiEffect && p.context.midiEffect.name) {
            names.push(p.context.midiEffect.name.toLowerCase());
        }
    }
    if (p.name) {
        names.push(p.name.toLowerCase());
    }
    return names;
};
